import { Dialog, styled } from '@mui/material';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    padding: '40px 24px',
    alignItems: 'center',
  },
}));
